import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const referrer = document.referrer;
        let source = 'Directo';

        if (referrer) {
          if (referrer.includes('facebook')) source = 'Facebook';
          else if (referrer.includes('instagram')) source = 'Instagram';
          else if (referrer.includes('linkedin')) source = 'LinkedIn';
          else if (referrer.includes('twitter') || referrer.includes('x.com')) source = 'Twitter/X';
          else if (referrer.includes('google')) source = 'Google';
          else if (referrer.includes('bing')) source = 'Bing';
          else source = 'Referencia';
        }

        await axios.post('/api/analytics/visit', {
          page: location.pathname,
          referrer,
          source
        });
      } catch (error) {
        console.error('Error tracking visit:', error);
      }
    };

    trackVisit();
  }, [location]);
};

export default usePageTracking;
